.dda-header {
    width: 100%;
    height: auto;
    background: var(--dda-surface-100);
    /* transition: all 300ms ease-in-out; */
    box-shadow: 0px 6px 7px 0px rgba(0, 0, 0, 0.13);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
}

body.transparent .dda-header {
    background: transparent;
    box-shadow: none;
}

.dda-header.white {
    background: var(--dda-surface-100) !important;
}

.dda-header .dda-container-fluid {
    position: relative;
}

body.transparent .dda-header.white {
    box-shadow: 0px 6px 7px 0px rgba(0, 0, 0, 0.13);
}

body.transparent .dda-header::before {
    content: "";
    width: 100%;
    height: 250px;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0.4) 63.02%, rgba(0, 0, 0, 0) 100%);
    position: absolute;
    top: 0;
    left: 0;
}

.dda-header.white::before {
    display: none !important;
}

.dda-head-logo {
    width: 90vw;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 20px;
    position: relative;
    direction: ltr !important;
}

.govt-logo img {
    height: 72px;
}

.entt-logo img {
    height: 54px;
}

body.transparent .logo-colored {
    display: none;
}

.logo-white {
    display: none;
}

body.transparent .logo-white {
    display: block;
}


.dda-header.white .dda-head-logo .logo-colored,
:root[data-theme='dark'] .dda-head-logo .logo-white {
    display: block;
}

.dda-header.white .dda-head-logo .logo-white,
:root[data-theme='dark'] .dda-head-logo .logo-colored {
    display: none;
}

:root[data-theme='dark'] .dda-header.white .dda-head-logo .logo-white {
    display: block;
}

.dda-menu-container {
    width: 90vw;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    position: relative;
}

.dda-main-navigation {
    display: flex;
    align-items: center;
    gap: 10px;
}

.dda-menu-overley {
    width: 100%;
    height: 100vh;
    background: #0000007e;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;
    display: none;
}

.dda-menu-overley.show-overley {
    display: block;
}

.hamburger-menu {
    display: flex;
    align-items: center;
}

.hamburger-menu>dda-tooltip {
    height: 22px;
}

.hamburger-menu-btn {
    width: 27px;
    height: 22px;
    padding: 0;
    background-color: transparent;
    border: transparent;
    position: relative;
}

.hamburger-menu-btn::before,
.hamburger-menu-btn::after {
    content: "";
}

.hamburger-menu-btn::before,
.hamburger-menu-btn::after,
.hamburger-line {
    content: "";
    width: 21px;
    height: 2px;
    border-radius: 4px;
    background-color: var(--dda-on-surface-30);
    position: absolute;
    left: 3px;
}

.hamburger-menu-btn::before {
    top: 4px;
}

.hamburger-menu-btn::after {
    bottom: 4px;
}

.hamburger-line {
    top: 10px;
}

.hamburger-menu-btn:hover::before,
.hamburger-menu-btn:hover::after,
.hamburger-menu-btn:hover .hamburger-line {
    background-color: var(--dda-color-primary-40);
}

body.transparent .hamburger-menu-btn::before,
body.transparent .hamburger-menu-btn::after,
body.transparent .hamburger-line {
    background-color: var(--dda-neutral-100) !important;
}


.hamburger-menu-btn.close-menu .hamburger-line {
    display: none;
}

.hamburger-menu-btn.close-menu::before {
    transform: rotate(45deg);
    top: 10px;
}

.hamburger-menu-btn.close-menu::after {
    transform: rotate(-45deg);
    bottom: 10px;
}

.hamburger-menu-text {
    width: 0;
    height: 0;
    opacity: 0;
    position: absolute;
}

.close-btn {
    position: absolute;
    inset-block-start: 1.5rem;
    inset-inline-end: 1.5rem;
    background: none;
    border: 0;
    font-size: 1.5em;
    z-index: 10;
    color: #999999;
}



.dda-header-megamenu {
    width: 100%;
    padding: 0 15px;
    position: fixed;
    top: 175px;
    left: 0;
}

.dda-header-submenu-item {
    min-height: 350px;
    background: var(--dda-surface-100);
    border-radius: 8px;
    margin: 0 auto;
    padding: 42px 15px;
    box-shadow: 0px 10px 15px -3px rgba(16, 24, 40, 0.1);
    position: relative;
}

.dda-header-submenu-item .dda-header-submenu-title {
    font-size: var(--font-h6);
    font-weight: var(--font-weight-regular);
    color: var(--dda-on-surface-0);
    text-transform: uppercase;
    padding-inline-start: 69px;
    margin-bottom: 10px;
}

.dda-header-submenu-item ul {
    display: flex;
    flex-direction: column;
    gap: 8px;
    list-style: none;
}

/*******************/
.dda-toolbar-menu,
.dda-toolbar-menu-sidemenu {
    padding: 0;
}

.dda-toolbar-menu ul,
.dda-toolbar-menu-sidemenu ul {
    display: flex;
    gap: 10px;
    justify-content: center;
    margin: 0px;
}

.dda-toolbar-menu ul li .tool-btn,
.dda-toolbar-menu-sidemenu ul li .tool-btn {
    height: 40px;
    min-width: 40px;
    background-color: var(--dda-surface-96);
    font-size: var(--font-body);
    color: var(--dda-on-surface-10);
    font-weight: var(--font-weight-regular);
    border: 0px;
    padding: 11px;
    border-radius: 50px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
}

.dda-toolbar-menu ul li .tool-btn:focus-visible,
.dda-toolbar-menu-sidemenu ul li .tool-btn:focus-visible {
    outline: solid 1px var(--dda-on-primary-variant-40) !important;
    outline-offset: -1px;
}

.dda-toolbar-menu ul li .tool-btn img,
.dda-toolbar-menu-sidemenu ul li .tool-btn img {
    height: 17px;
    width: 17px;
}


.da-header-search {
    display: none;
}


.dda-toolbar-menu ul li .tool-btn i,
.dda-toolbar-menu ul li .tool-btn svg,
.dda-toolbar-menu-sidemenu ul li .tool-btn i,
.dda-toolbar-menu-sidemenu ul li .tool-btn svg {
    font-size: 20px;
    color: var(--dda-on-surface-variant-30);
}

@media only screen and (min-width: 768px) {

    body.transparent .dda-toolbar-menu ul li .tool-btn,
    body.transparent .dda-toolbar-menu-sidemenu ul li .tool-btn {
        background-color: rgb(41 42 45 / 14%);
        color: var(--dda-neutral-100);
    }

    body.transparent .dda-toolbar-menu ul li .tool-btn i,
    body.transparent .dda-toolbar-menu ul li .tool-btn svg,
    body.transparent .dda-toolbar-menu-sidemenu ul li .tool-btn i,
    body.transparent .dda-toolbar-menu-sidemenu ul li .tool-btn svg {
        color: var(--dda-neutral-100);
    }
}


.dda-search {
    position: relative;
}
.dda-search i,
.dda-search svg {
    font-size: 21px;
    color: var(--dda-on-surface-variant-30);
    position: absolute;
    top: 9px;
    inset-inline-start: 10px;
    z-index: 1;
}

.dda-header-search-input {
    padding: 0px !important;
}

.dda-search input[type="text"] {
    width: 110px;
    height: 40px;
    background-color: transparent;
    border: 0px;
    font-family: var(--font-family-main);
    font-size: var(--font-body);
    font-weight: var(--font-weight-regular);
    color: var(--dda-on-surface-0);
    border-radius: 100px;
    padding-inline-start: 40px !important;
    padding-inline-end: 10px;
    /* transition: all 250ms ease; */
}

.dda-search input[type="text"]:focus {
    width: 250px;
    /* outline: 0; */
}

.dda-search input[type="text"]::-ms-input-placeholder {
    color: var(--dda-on-surface-0);
}

.dda-search input[type="text"]::placeholder {
    color: var(--dda-on-surface-0);
}

body.transparent .dda-header .dda-search input[type="text"] {
    color: var(--dda-surface-100);
}

body.transparent .dda-search input[type="text"]::-ms-input-placeholder {
    color: var(--dda-neutral-100);
}

body.transparent .dda-search input[type="text"]::placeholder {
    color: var(--dda-neutral-100);
}

body.transparent .dda-search i {
    color: var(--dda-neutral-100);
}

.dda-sidemenu {
    display: none;
    width: 375px;
    background: var(--dda-surface-100);
    box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.12);
    position: fixed;
    top: 0px;
    inset-inline-start: -375px;
    bottom: 0px;
    z-index: 9;
    /* transition: left 0.5s ease; */
}

.dda-sidemenu-content {
    display: flex;
    flex-direction: column;
    gap: 15px;
    padding: 32px;
    overflow-y: auto;
    height: 100%;
    position: relative;
}

.dda-sidemenu-content::-webkit-scrollbar {
    width: 6px;
}

.dda-sidemenu-content::-webkit-scrollbar-track {
    background: var(--dda-surface-variant-90);
}

.dda-sidemenu-content::-webkit-scrollbar-thumb {
    background: var(--dda-surface-variant-80);
}

.dda-sidemenu-content::-webkit-scrollbar-thumb:hover {
    background: var(--dda-color-primary-40);
}

.dda-side-nav-title {
    font-size: var(--font-h6);
    font-weight: var(--font-weight-regular);
    text-transform: uppercase;
    color: var(--dda-on-surface-0);
}

ul.main_side_menu {
    margin: 0;
    margin-bottom: 30px !important;
    padding: 0px;
}

ul.main_side_menu li {
    list-style: none;
    padding: 0;
}

ul.main_side_menu li a {
    display: flex;
    justify-content: space-between;
    padding-top: 13px;
    padding-bottom: 14px;
    text-decoration: none;
    font-size: var(--font-body);
    font-weight: var(--font-weight-regular);
    color: var(--dda-on-surface-0);
    border-bottom: 1px solid var(--dda-surface-90);
    width: 100%;
    cursor: pointer;
    position: relative;
}

.main_sub_menu>ol>li:last-child>a {
    border-bottom: 0;
}

ul.main_side_menu li a.showSub::after,
ul.main_side_menu li a.showSubSub::after {
    content: "";
    width: 9px;
    height: 9px;
    border-right: solid 2px var(--dda-color-primary-40);
    border-bottom: solid 2px var(--dda-color-primary-40);
    position: absolute;
    top: 50%;
    inset-inline-end: 3px;
    margin-top: -4.5px;
    transform: rotate(-45deg);
    /* transition: all 250ms ease; */
}

ul.main_side_menu li a i {
    display: block;
}

:root[dir='rtl'] ul.main_side_menu li a i {
    transform: rotate(180deg);
}

:root[dir='rtl'] ul.main_side_menu li a.showSub::after,
:root[dir='rtl'] ul.main_side_menu li a.showSubSub::after {
    transform: rotate(135deg);
}

:root[dir='rtl'] .material-icons {
    direction: rtl;
}


ul.main_side_menu li a:hover,
ul.main_side_menu li a.active,
ul.main_side_menu li a.icon_arrow {
    color: var(--dda-color-primary-40);
    border-bottom: solid 2px var(--dda-color-primary-40);
    padding-bottom: 13px;
}

ul.main_side_menu li a.showSub.icon_arrow::after,
ul.main_side_menu li a.showSubSub.icon_arrow::after {

    border-right: solid 2px var(--dda-color-primary-40);
    border-bottom: solid 2px var(--dda-color-primary-40);

}

ul.main_side_menu li .main_sub_menu {
    display: none;
    position: fixed;
    /* margin-top: -50px; */
    inset-inline-start: 380px;
    width: 350px;
    background: var(--dda-surface-100);
    padding: 25px 20px 15px 20px;
    border-radius: 10px;
    box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.12);
}

ul.main_side_menu li .main_sub_menu.showSubMenu {
    display: block;
}

.main_sub_menu ol {
    padding: 0px;
}

ul.main_side_menu .main_sub_menu {
    padding: 25px 10px 15px 20px;
}

.main_sub_menu>ol {
    max-height: 380px;
    overflow: auto;
    padding: 2px 2px 10px 2px;
}

.dda-side-nav__title {
    font-size: var(--font-h6);
    color: var(--font-h6);
    font-weight: var(--font-weight-regular);
    text-transform: uppercase;
    margin-bottom: 10px;
}

.main_sub_menu>ol::-webkit-scrollbar {
    width: 3px;
}

.main_sub_menu>ol::-webkit-scrollbar-track {
    background: #fafafa;
}

.main_sub_menu>ol::-webkit-scrollbar-thumb {
    background: var(--dda-neutral-variant-92);
}

.main_sub_menu>ol::-webkit-scrollbar-thumb:hover {
    background: var(--dda-neutral-variant-92);
}

.main_sub_menu li {
    position: relative;
}

ul.main_side_menu .main_sub_menu .main_sub_menu {
    inset-inline-start: 735px;
}

ul.main_side_menu .main_sub_menu .main_sub_menu .main_sub_menu {
    inset-inline-start: 1090px;
}

.side-nav-close-btn {
    top: 1.5rem;
    inset-inline-end: 1.5rem;
}

.dda-sidemenu-bottom {
    width: 100%;
    position: fixed;
    inset-inline-start: 0;
    bottom: 0;
    display: none;
}

.dda-sidemenu-gov-logo {
    display: flex;
    justify-content: center;
}

.dda-sidemenu-gov-logo a {
    display: inline-block;
}

.dda-sidemenu-gov-logo img {
    height: 44px;
}

/*Accessibility*/
.dda-accessibility-wrap {
    width: 100%;
    padding: 0 10px;
    position: fixed;
    top: 185px;
    left: 0;
}

.dda-accessibility {
    max-width: 880px;
    margin: 0 auto;
    background: var(--dda-surface-100);
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.12);
    position: relative;
    display: none;
    /* transition: left 0.5s ease; */
}

.mobile-accessibility {
    padding-top: 35px;
    position: absolute;
    top: 0px;
    z-index: 10;
    height: 100%;
}

.mobile-accessibility-content {
    display: block;
    padding: 0 14px;
    height: 100%;
    overflow-y: auto;
}

.mobile-accessibility-content::-webkit-scrollbar {
    width: 6px;
}

.mobile-accessibility-content::-webkit-scrollbar-track {
    background: var(--dda-surface-variant-90);
}

.mobile-accessibility-content::-webkit-scrollbar-thumb {
    background: var(--dda-surface-variant-80);
}

.mobile-accessibility-content::-webkit-scrollbar-thumb:hover {
    background: var(--dda-color-primary-40);
}

.dda-accessibility-item {
    border-inline-start: solid 1px #E5E5E5;
}

.dda-accessibility .dda-row .dda-accessibility-item:first-child {
    border: 0px;
}

.dda-theme-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
    border: 0px;
}

.close_accessibility {
    top: 5px;
    inset-inline-end: 5px;
}

.dda-login-popup.desktop,
.dda-login-popup.mobile {
    display: none;
}

.dda-login-popup {
    background-color: var(--dda-surface-100);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
        0 4px 6px -4px rgba(0, 0, 0, 0.1);
    border: 1px solid var(--dda-surface-variant-90);
    border-radius: 0.5rem;
    padding: 0.75rem;
    z-index: 50;
    height: fit-content;
    min-width: 110px;
}

.dda-login-popup.desktop {
    position: fixed;
    top: 170px;
    bottom: auto;
    inset-inline-end: 5.5rem;
}

.dda-login-popup.mobile {
    position: fixed;
    bottom: 2.5rem;
    inset-inline-end: 6rem;
}

.dda-login-popup ul> :not(:last-child) {
    border-bottom: 1px solid var(--dda-surface-variant-90);
}

.dda-login-popup a {
    text-align: start;
    padding-inline: 0.5rem;
    padding-block: 0.25rem;
    display: inline-block;
    text-decoration: none;
    width: 100%;
    color: var(--dda-surface-0);
    border-radius: 4px;
}

.dda-login-popup a:hover {
    background-color: var(--dda-on-primary-98);
    color: var(--dda-on-primary-variant-40);
}

@media (min-width: 640px) {
    .dda-login-popup {
        inset-inline-end: 8rem;
    }
}

@media (max-width: 768px) {
    .dda-login-popup.desktop{
        display: none !important;
    }
}

@media (min-width: 767px) {
    .dda-login-popup.mobile{
        display: none !important;
    }
}

/*Mobile view*/
.dda-mobile-entt-logo,
.dda-mobile-search {
    display: none;
    overflow: hidden;
}

.dda-mobile-search a,
.dda-mobile-search button {
    width: 30px;
    padding: 0;
    background: transparent;
    border: transparent;
}

.dda-mobile-search a i,
.dda-mobile-search a svg,
.dda-mobile-search button i,
.dda-mobile-search button svg {
    font-size: 23px;
    color: var(--dda-on-surface-variant-30);
}

.dda-mobile-search a svg,
.dda-mobile-search button svg {
    fill: var(--dda-on-surface-variant-30);
}

body.transparent .dda-mobile-search a i,
body.transparent .dda-mobile-search a svg,
body.transparent .dda-mobile-search button i,
body.transparent .dda-mobile-search button svg {
    color: var(--dda-neutral-100);
}

.maincontent {
    padding-top: 170px;
    padding-bottom: 100px;
}


@media screen and (max-width: 767px) {
    body.transparent .dda-header::before {
        height: 130px;
    }

    .dda-header {
        padding: 0 !important;
    }

    .dda-menu-overley {
        display: none !important;
    }

    .side-nav-close-btn {
        display: block;
    }

    .dda-menu-container {
        width: 100vw;
        height: 80px;
        position: relative;
    }

    .dda-head-logo {
        display: none;
    }

    .dda-mobile-entt-logo,
    .dda-mobile-search {
        display: block;
    }

    .dda-mobile-entt-logo img {
        height: 40px;
    }

    .dda-toolbar-menu {
        position: absolute;
        width: 0;
        display: none;
    }

    .dda-toolbar-menu ul li .tool-btn {
        display: none;
    }

    .dda-accessibility-wrap {
        top: 81px;
        padding: 0;
    }

    .dda-accessibility-wrap .dda-accessibility {
        height: calc(100vh - 82px);
        border-radius: 0px;
        box-shadow: none;
    }

    .dda-accessibility .dda-row {
        gap: 30px;
    }

    .dda-accessibility-item {
        border: 0px;
    }

    .dda-sidemenu-content {
        height: calc(100% - 130px);
        padding: 32px 17px 32px 32px;
    }

    .dda-sidemenu .dda-sidemenu-bottom {
        display: block;
        position: initial;
    }

    .main_side_menu .dda-side-nav__title {
        display: none;
    }

    .main_side_menu_wrap {
        height: calc(100% - 100px);
        overflow: auto;
        padding: 5px;
    }

    .main_side_menu_wrap::-webkit-scrollbar {
        width: 3px;
    }

    .main_side_menu_wrap::-webkit-scrollbar-track {
        background: #fafafa;
    }

    .main_side_menu_wrap::-webkit-scrollbar-thumb {
        background: #e7e7e7;
    }

    .main_side_menu_wrap::-webkit-scrollbar-thumb:hover {
        background: #d4d4d4;
    }

    .dda-sidemenu {
        width: 100%;
        top: 80px;
        padding-inline-end: 15px;
    }

    ul.main_side_menu li a {
        padding-left: 10px;
        padding-right: 10px;
    }

    ul.main_side_menu li .main_sub_menu {
        position: inherit !important;
        inset-inline-start: inherit !important;
        top: inherit ! Important;
        margin: 0px !important;
        width: 100% !important;
        padding: 0px;
        box-shadow: none;
        border-radius: 0px;
    }

    ul.main_side_menu li a.showSub::after {
        transform: rotate(45deg);
        inset-inline-end: 13px;
    }

    ul.main_side_menu li a.icon_arrow::after {
        transform: rotate(-135deg);
    }

    :root[dir='rtl'] ul.main_side_menu li a.showSub::after,
    :root[dir='rtl'] ul.main_side_menu li a.showSubSub::after {
        transform: rotate(45deg);
    }

    :root[dir='rtl'] ul.main_side_menu li a.showSub.icon_arrow::after,
    :root[dir='rtl'] ul.main_side_menu li a.showSub.icon_arrow::after {
        transform: rotate(-135deg);
    }

    .main_sub_menu>ol>li:last-child>a {
        border-bottom: 1px solid #00000022;
    }

    ul.main_side_menu li a.icon_arrow,
    ul.main_side_menu .main_sub_menu li a .icon_arrow {
        color: var(--dda-color-primary-40);
    }

    ul.main_side_menu .main_sub_menu ol {
        height: auto;
        max-height: none;
        padding: 0;
        padding-inline-start: 10px;
    }

    .maincontent {
        padding-top: 100px;
    }

    ul.main_side_menu a.showSub.icon_arrow {
        background-color: var(--dda-on-primary-94);
    }

    ul.main_side_menu .main_sub_menu.showSubMenu {
        background-color: var(--dda-on-primary-98);
    }

    ul.main_side_menu li a:hover {
        padding-bottom: 13px;
    }

}

@media (max-width: 1200px) {}

@media (max-width: 1024px) {
    .dda-header {
        padding: 10px 0;
    }

    .dda-head-logo,
    .dda-menu-container {
        width: 100vw;
    }
}

@media (prefers-reduced-motion: no-preference) {
    .dda-search input[type="text"] {
        transition: all 250ms ease;
    }

    .dda-header {
        transition: all 300ms ease-in-out;
    }

    .dda-sidemenu {
        transition: left 0.5s ease;
    }

    ul.main_side_menu li a.showSub::after,
    ul.main_side_menu li a.showSubSub::after {
        transition: all 250ms ease;
    }

    .dda-accessibility {
        transition: left 0.5s ease;
    }
}


/* @media screen and (max-height: 552px) {
    ul.main_side_menu li .main_sub_menu {
        position: inherit;
        margin-top: 0px;
        width: 100%;
        padding: 5px 0px 15px 20px;
        box-shadow: none;
        inset-inline-start: inherit !important;
    }
    .dda-side-nav__title{
        display: none;
    }
} */